import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const PregnancyPage = lazy(() => import("./PregnancyPage"));

const PregnancyPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <PregnancyPage />
    </Suspense>
  );
};

export default PregnancyPageLazy;
